import { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClearincomingCall } from "../../../../redux/consultant/consultantAction";
import { useSocket } from "../../../../utils/Socket.Provider";
import { useGetConsultantProfileQuery } from "../../../../redux/rtk/apiRtk";
import debounce from "lodash.debounce";

/**
 * Hook to manage call state and actions
 * @returns {Object} Call management functions and state
 */
const useCallManager = (callData) => {
  // Call states: "connecting", "active", "ending", "ended"
  const [callStatus, setCallStatus] = useState("connecting");
  const [audioConnected, setAudioConnected] = useState(false);
  const [participantJoined, setParticipantJoined] = useState(false);
  const [callError, setCallError] = useState(null);
  // const callData = useSelector((state) => state?.consultant?.incomingCall);
  const dispatch = useDispatch();
  const { socket } = useSocket();
  const { data: ConsultantProfileData } = useGetConsultantProfileQuery("");
  // Handle call connection success
  const handleCallConnected = useCallback(() => {
    setCallStatus("active");
    setAudioConnected(true);
  }, []);

  // Handle participant joined
  const handleParticipantJoined = useCallback(() => {
    setParticipantJoined(true);
  }, []);

  // Handle audio connection issues
  const handleAudioIssue = useCallback((error) => {
    setAudioConnected(false);
    setCallError(error || "Audio connection issue");
  }, []);

  // Handle socket events for call management
  useEffect(() => {
    if (!socket) return;

    // Handle remote end call
    const handleRemoteEndCall = () => {
      setCallStatus("ending");
      console.log("comming remote ending soket");

      // Clear call state after a delay
      setTimeout(() => {
        dispatch(ClearincomingCall());
        setCallStatus("ended");
      }, 1000);
    };

    // Handle call accepted event
    const handleCallAccepted = () => {
      setCallStatus("connecting");
    };

    socket.on("end-call", handleRemoteEndCall);
    socket.on("accept-call", handleCallAccepted);

    return () => {
      socket.off("end-call", handleRemoteEndCall);
      socket.off("accept-call", handleCallAccepted);
    };
  }, [socket, dispatch]);

  // Function to end the call
  const endCall = useMemo(() => {
    return debounce(() => {
      setCallStatus("ending");

      const userId = callData?.fromUser;
      const meetingId = callData?.meetingId;

      if (socket && ConsultantProfileData?._id) {
        console.log("ending call calling ....");
        console.log({
          toUser: userId,
          fromUser: ConsultantProfileData._id,
          consultantid: ConsultantProfileData._id,
          user: ConsultantProfileData._id,
          meetingId: meetingId,
        });
        // {
        //     "fromUser": "6899cfbc49ef4b00fe858a5c",
        //     "consultantid": "6899cfbc49ef4b00fe858a5c",
        //     "user": "6899cfbc49ef4b00fe858a5c"
        // }
        socket.emit("end-call", {
          toUser: userId,
          fromUser: ConsultantProfileData._id,
          consultantid: ConsultantProfileData._id,
          user: ConsultantProfileData._id,
          meetingId: meetingId,
        });
      }

      setTimeout(() => {
        dispatch(ClearincomingCall());
        // navigate("/profile");
      }, 2000);
    }, 1000); // 1 second debounce
  }, [
    callData?.fromUser,
    callData?.meetingId,
    socket,
    ConsultantProfileData?._id,
    dispatch,
  ]);
  // Function to retry audio connection
  const retryAudioConnection = useCallback(() => {
    setCallError(null);
    setCallStatus("connecting");
    // Implementation would depend on your video SDK
  }, []);

  return {
    callStatus,
    audioConnected,
    participantJoined,
    callError,
    endCall,
    handleCallConnected,
    handleParticipantJoined,
    handleAudioIssue,
    retryAudioConnection,
    ConsultantProfileData,
  };
};

export default useCallManager;
